import React from 'react'
import RecoverPasswordFirstStep from '../RecoverPasswordFirstStep';
import RecoverPasswordSecondStep from '../RecoverPasswordSecondStep';
import {isRutValid,beforeMaskedValueChangeRut} from "../../../../common/utils/utilsFunc"
import RecoverPasswordContextProvider, {ACTIONS, RecoverPasswordContext} from '../../context/RecoverPasswordContextProvider';
import AlertModal from "../../../../common/components/AlertModal";
import Loading from "../../../../common/components/Loading";
import { useModal } from "@clayui/modal";
import { urlParams } from '../../../../common/utils/utilsFunc'

function RecoverPasswordController({props}) {
    const [state, dispatch] = React.useContext(RecoverPasswordContext);
    const [values, setValues] = React.useState({})
    const [page, setPage] = React.useState(0)
    const [loading, setLoading] = React.useState(false)
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false)
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const [inputValidateSecond, setInputValidateSecond] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const [checkPassword, setCheckPassword] = React.useState({});
    const [visibleModalConfirm, setVisibleModalConfirm] = React.useState(false);
    const [visibleModalError, setVisibleModalError] = React.useState(false);
    const [visibleModalConfirmAceptar, setVisibleModalConfirmAceptar] = React.useState(false);

    // NUEVO: modal por motivo de seguridad
    const [visibleModalCompromised, setVisibleModalCompromised] = React.useState(false);

    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModalConfirm(false);
            setVisibleModalError(false);
            setVisibleModalConfirmAceptar(false);
            // NUEVO: cerrar también el modal de seguridad
            setVisibleModalCompromised(false);
        },
    });

    // === Helpers de cookies ===
    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }
    // (Opcional) si quieres limpiar la cookie después de usarla:
    // function deleteCookie(name) {
    //   document.cookie = `${name}=; Path=/; Max-Age=0`;
    // }

    React.useEffect(() => {
        const urlRut = urlParams.get('rut')
        if(urlRut) {
            setValues({ ...values, rut: urlRut })
        }

        // NUEVO: si llega reason=security, mostrar modal
        const reason = urlParams.get('reason');
        if (reason === 'security') {
            setVisibleModalCompromised(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    React.useEffect(() => {
        if(state.responseData) {
            const objResponse = state.responseData;

            switch(objResponse?.response?.status) {
                case 200:
                    props.setGlobalAlert("Contraseña actualizada con éxito", "success",true,"Confirmación");
                    break;
                case 500:
                    props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning",true,"Atención");
                    break;
                case 400:
                    props.setGlobalAlert("Por favor, compruebe sus datos y vuelva a intentarlo.", "warning",true,"Atención");
                    break;
                default:
                    props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning",true,"Atención");
                    break;
            }
        }
    },[state.responseData]);

    function checkPasswordFunc(password){
        let checkPass = {}
        let m;
        if( !(m = password.match(/[a-z]/g))){
            checkPass.lowerCase = false
        } else {
            checkPass.lowerCase = true
        }

        if( !(m = password.match(/[A-Z]/g))){
            checkPass.upperCase = false
        } else {
            checkPass.upperCase = true
        }

        if( !(m = password.match(/[0-9]/g))){
            checkPass.containsNumber = false
        } else {
            checkPass.containsNumber = true
        }

        if(password.length < 8){
            checkPass.minLength = false
        } else {
            checkPass.minLength = true
        }

        setCheckPassword(checkPass)
        return checkPass
    }

    function onChangeReCaptcha(value) {
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function validateFirstStep(){
        let errors = {
            empty: {},
            error: {},
            msg: {}
        };

        if (values?.rut) {
            errors.empty.rut = false;

            if (!isRutValid(values?.rut)) {
                errors.error.rut = true;
                errors.msg.rut = "Debes ingresar un RUT válido.";

            } else {
                errors.error.rut = false;
            }

        } else {
            errors.empty.rut = true;
            errors.msg.rut = "Debes ingresar el Número de carnet  de identidad o RUT";
        }

        setInputValidate(errors);
        return errors;
    }

    function handleClickFirstStep(){
        const objErros = validateFirstStep();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (!verifReCaptcha) {
            props.setGlobalAlert("Falta validar que no eres un robot.", "warning");
        } else {
            setLoading(true);
            dispatch({
                payload: values?.rut,
                type: ACTIONS.SET_FORGOT_PASSWORD,
            });
        }
    }

    React.useEffect(() => {
        setLoading(false);
        if(state?.forgotPasswordResponse?.data) {
            if(state.forgotPasswordResponse?.response?.ok){
                setVisibleModalConfirm(true);
            } else {
                if(state.forgotPasswordResponse?.data?.status === 404) {
                    setVisibleModalError(true);
                } else {
                    props.setGlobalAlert(state.forgotPasswordResponse?.data?.msg ? state.forgotPasswordResponse?.data?.msg : "El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
                }
            }
        }

    },[state.forgotPasswordResponse]);

    function validateSecondStep() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (values.code) {
            errors.empty.code = false;
        } else {
            errors.empty.code = true;
            errors.msg.code = "Debe ingresar el código de confirmación"
        }

        if (values.newPassword) {
            errors.empty.newPassword = false;
        } else {
            errors.empty.newPassword = true;
            errors.msg.newPassword = "Debe ingresar el contraseña nueva"
        }

        if (values.confirmNewPassowrd) {
            errors.empty.confirmNewPassowrd = false;
        } else {
            errors.empty.confirmNewPassowrd = true;
            errors.msg.confirmNewPassowrd = "Debe ingresar el confirmacion del contraseña nueva"
        }

        setInputValidateSecond(errors);
        return errors
    }

    function handleClickSecondStep(){
        const objErros = validateSecondStep();

        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if((Object.entries(checkPassword).filter(([key, value]) =>  value === false).length > 0)){
            props.setGlobalAlert("Complete todos los campos obligatorios correctamente.","warning");
            setInputValidateSecond({...inputValidateSecond, ...inputValidateSecond.empty.newPassword = true, ...inputValidateSecond.msg.newPassword = "La contraseña debe respetar las reglas a continuación.", ...inputValidateSecond.empty.confirmNewPassowrd = false, ...inputValidateSecond.msg.confirmNewPassowrd = ""})
        } else if(values.newPassword !== values.confirmNewPassowrd) {
            props.setGlobalAlert("Las contraseñas deben ser las mismas.","warning");
            setInputValidateSecond({...inputValidateSecond, ...inputValidateSecond.empty.confirmNewPassowrd = true, ...inputValidateSecond.msg.confirmNewPassowrd = "Las contraseñas deben ser las mismas.", ...inputValidateSecond.empty.newPassword = false, ...inputValidateSecond.msg.newPassword = "",})
        } else {
            setLoading(true);
            dispatch({
                payload: {code:values?.code,rut:values?.rut,password:values?.newPassword},
                type: ACTIONS.SET_CONFIRM_FORGOT_PASSWORD,
            });
        }
    }

    React.useEffect(() => {
        setLoading(false);
        if(state?.confirmForgotPasswordResponse?.data) {
            const objResponse = state.confirmForgotPasswordResponse;
            if(objResponse?.data?.ok){
                setVisibleModalConfirmAceptar(true);
            } else {
                props.setGlobalAlert(objResponse?.data?.msg, "warning", true, "Advertencia");
            }
        }
    },[state.confirmForgotPasswordResponse]);

    return (
        <div>
            {page === 0 ?
                <RecoverPasswordFirstStep props={{...props,setValues,values,setInputValidate,inputValidate,onChangeReCaptcha,setPage,handleClickFirstStep,beforeMaskedValueChangeRut}} />
                :
                <RecoverPasswordSecondStep props={{...props,setValues,values,setInputValidateSecond,inputValidateSecond,onChangeReCaptcha,setPage,handleClickSecondStep,checkPasswordFunc, checkPassword, setCheckPassword, visibleModalConfirmAceptar, observer, onClose}} />
            }
            {loading &&
                <Loading />
            }
            {visibleModalConfirm && (
                <AlertModal
                    titleModal="Información"
                    observer={observer}
                    onClose={onClose}
                    msgModal={(function () {
                        const emailMaskedFromCookie = getCookie("cgem");

                        // Si existe cookie -> usa el texto fijo con el correo enmascarado
                        if (emailMaskedFromCookie) {
                            return (
                                "Se ha enviado un correo electrónico con el código de confirmación para restablecer tu contraseña.\n" +
                                `Por favor, revisa la bandeja de entrada del correo registrado ${emailMaskedFromCookie}.\n` +
                                "Introduce el código en la siguiente pantalla para continuar."
                            );
                        }

                        // Si no existe cookie -> usa el texto de la propiedad existente
                        return props?.email_confirmation_text_get_password;
                    })()}
                    status="info"
                    funcClick={() => {
                        setPage(1);
                        onClose();
                        // (Opcional) limpiar cookie si así lo decides:
                        // deleteCookie("cgem");
                    }}
                    btnCancel={false}
                    labelBtnConfirm={"Ok"}
                    confirm={true}
                />
            )}

            {visibleModalError && (
                <AlertModal
                    titleModal="Información"
                    observer={observer}
                    onClose={onClose}
                    msgModal={"El rut ingresado no se encuentra registrado.  ¿Deseas registrarte?"}
                    status="info"
                    funcClick={() => {
                        window.open(`/web/guest/registro-de-usuario`, '_self');
                        onClose();
                    }}
                    labelBtnCancel={"No"}
                    btnCancel={true}
                    labelBtnConfirm={"Si"}
                    confirm={true}
                />
            )}

            {visibleModalCompromised && (
                <AlertModal
                    titleModal="Seguridad de tu cuenta"
                    observer={observer}
                    onClose={() => setVisibleModalCompromised(false)}
                    msgModal={props?.security_reason_text || "Por seguridad necesitamos que actualices tu contraseña."}
                    status="info"
                    btnCancel={false}
                    labelBtnConfirm={"Continuar"}
                    confirm={true}
                    funcClick={() => setVisibleModalCompromised(false)}
                />
            )}

        </div>
    )
}

const RecoverPasswordControllerWithProvider = ({ props }) => (
    <RecoverPasswordContextProvider>
        <RecoverPasswordController props={props} />
    </RecoverPasswordContextProvider>
);
export default RecoverPasswordControllerWithProvider;